<div class="color-tag-stepper">
  <span
    *ngFor="let s of steps"
    class="step"
    [ngClass]="{ active: s.step === currentStep, done: s.step < currentStep }">
    {{ s.step }} · {{ s.label }}
  </span>
</div>
